var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAtm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.8125 0.566895H19.8125C20.0777 0.566895 20.3321 0.672251 20.5196 0.859788C20.7071 1.04732 20.8125 1.30168 20.8125 1.56689V17.5669C20.8125 17.8321 20.7071 18.0865 20.5196 18.274C20.3321 18.4615 20.0777 18.5669 19.8125 18.5669H1.8125C1.54728 18.5669 1.29293 18.4615 1.10539 18.274C0.917857 18.0865 0.8125 17.8321 0.8125 17.5669V1.56689C0.8125 1.30168 0.917857 1.04732 1.10539 0.859788C1.29293 0.672251 1.54728 0.566895 1.8125 0.566895ZM18.8125 8.56689H2.8125V16.5669H18.8125V8.56689ZM18.8125 6.56689V2.56689H2.8125V6.56689H18.8125ZM12.8125 12.5669H16.8125V14.5669H12.8125V12.5669Z",
    fill: "#0D458A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12.7812,
    y: 12.4927,
    width: 4.03843,
    height: 2.08175,
    fill: "#3AA64C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtm);
export default __webpack_public_path__ + "static/media/atm.a7c82b6f1c8288d371f5ea66e0ff179c.svg";
export { ForwardRef as ReactComponent };